<template>
  <LandingPage
    :page="page"
    :isNotFound="isNotFound"
    :shareUrl="shareUrl"
    :taglineFallback="`Residency at ${venue_name}`"
    loadingText="Loading Residency..."
  />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { toRefs } from 'vue'
import { useRoute } from 'vue-router'

import LandingPage from '@/modules/guestUi/components/templates/LandingPage.vue'
import { useLandingPage } from '@/modules/guestUi/composables/useLandingPage'
import {
  buildResidencyCanonicalPath,
  buildResidencyJsonLd,
  buildResidencyPath,
  buildResidencyUrl,
} from '@/modules/residency/utils/seo'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'

const props = defineProps<{ slug: string }>()
const { slug } = toRefs(props)

const checkoutStore = useCheckoutStore()
const settingStore = useSettingStore()
const { venue_name } = storeToRefs(settingStore)
const route = useRoute()

const { page, isNotFound, shareUrl } = useLandingPage({
  fetchPage: () => checkoutStore.getResidency(slug.value),
  buildPagePath: residencySlug => buildResidencyPath(residencySlug, route.path),
  buildCanonicalPath: residency => buildResidencyCanonicalPath(residency, route.path),
  buildJsonLd: residency =>
    buildResidencyJsonLd(
      residency,
      settingStore,
      buildResidencyUrl(settingStore.canonicalDomain, residency.slug, route.path),
    ),
  pageVersion: { key: 'residency_page_version', version: 'landing_v2' },
})
</script>
